import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import TopNavbar from "../components/Nav/TopNavbar";
import {
  CheckCircle,
  Target,
  Layers,
  Hourglass,
  GraduationCap,
  Banknote,
  Clock,
} from "lucide-react"; // Updated icons
import Contact from "../components/Sections/Footer";
import Footer from "../components/Sections/Footer";
import FormationUnavailableFallback from "./FormationUnavailableFallback";

const TrainingDetail = () => {
  useEffect(() => {
    // Scroll to the top of the page or component
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures this only runs once on mount
  const location = useLocation();
  const field = location.state;

  if (!field) {
    return (
      <div className="">
        <TopNavbar />
        <div style={{ marginTop: "10%" }}></div>
        <FormationUnavailableFallback />

        <Footer />
      </div>
    );
  }

  return (
    <>
      <TopNavbar />
      <div className="max-w-7xl mx-auto px-6 py-8 mt-24 md:mt-20">
        <h2 className="text-4xl font-bold text-gray-800 mb-6">{field.title}</h2>

        {/* Image and Basic Information Section */}
        <div className="flex flex-col md:flex-row md:space-x-8 mb-8">
          {/* Image Section */}
          <div className="w-full md:w-1/3 mb-6">
            <img
              src={field.image}
              alt={field.title}
              className="w-full h-72 object-cover rounded-lg shadow-lg"
            />
          </div>

          {/* Formation Details */}
          <div className="w-full md:w-2/3 space-y-4">
            <div className="flex items-center space-x-2">
              <Target className="text-blue-500" />
              <h3 className="text-xl font-semibold text-gray-800">
                Formation :
              </h3>
              <p className="text-lg text-gray-600">{field.name}</p>
            </div>

            <div className="flex items-center space-x-2">
              <Layers className="text-purple-500" />
              <h3 className="text-xl font-semibold text-gray-800">Détails :</h3>
            </div>
            <p className="text-lg text-gray-600">{field.description}</p>
          </div>
        </div>

        {/* Objectives & Modalities in Columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          {/* Objectives Section */}
          <div className="bg-gray-100 p-6 rounded-lg shadow-md">
            <div className="flex items-center space-x-2 mb-3">
              <CheckCircle className="text-green-500" />
              <h3 className="text-xl font-semibold text-gray-800">
                Objectifs :
              </h3>
            </div>
            <ul className="list-disc pl-5 space-y-2">
              {field.objectives?.map((objective, index) => (
                <li key={index} className="text-lg text-gray-600">
                  {objective}
                </li>
              ))}
            </ul>
          </div>

          {/* Modalities Section */}
          <div className="bg-gray-100 p-6 rounded-lg shadow-md">
            <div className="flex items-center space-x-2 mb-3">
              <Clock className="text-orange-500" />
              <h3 className="text-xl font-semibold text-gray-800">
                Modalités :
              </h3>
            </div>
            <ul className="list-disc pl-5 space-y-2">
              {field.modalities?.map((modality, index) => (
                <li key={index} className="text-lg text-gray-600">
                  {modality}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Grouped Section for Niveau, Durée, Financement, and Prix */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 bg-gray-100 p-6 rounded-lg shadow-md">
          <div className="flex flex-col">
            <p className="text-lg font-semibold text-gray-800 flex items-center">
              <GraduationCap className="mr-2 text-indigo-500" /> Niveau :
            </p>
            <p className="text-lg text-gray-600">{field.levels}</p>
          </div>

          <div className="flex flex-col">
            <p className="text-lg font-semibold text-gray-800 flex items-center">
              <Hourglass className="mr-2 text-orange-500" /> Durée :
            </p>
            <p className="text-lg text-gray-600">{field.duration}</p>
          </div>

          <div className="flex flex-col">
            <p className="text-lg font-semibold text-gray-800 flex items-center">
              <Banknote className="mr-2 text-teal-500" /> Financement :
            </p>
            <p className="text-lg text-gray-600">{field.financing}</p>
          </div>

          {/* <div className="flex flex-col">
            <p className="text-lg font-semibold text-gray-800 flex items-center">
              <Tag className="mr-2 text-pink-500" /> Prix :
            </p>
            <p className="text-lg text-gray-600">{field.price}</p>
          </div> */}
        </div>
      </div>
      <Contact />
    </>
  );
};

export default TrainingDetail;
